export default __webpack_public_path__ + "static/media/man_oneB.20226a29.png";